const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-plans-comparison-table"
);

if (blocks.length) {
  import("./view-frontend.js").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
